import React from 'react';
import {
  Row,
  Col,
} from "react-bootstrap";
import { getMessage } from "CONFIG/i18n";

// Asset
import icBack from "ASSETS/Images/back.svg";

// Utilities
import { OPERATOR_STATUS } from "UTILS/Constants";

// Components
import StatusLabel from './StatusLabel';
import "./CallWaiting.less";

const CallWaiting = (props) => {

  return(
    <>
      <div className="callWaiting">
        <div className="col-xl-2 col-12 d-flex align-items-center backBtn pl-3 pt-2">
          <img 
            src={icBack} 
            className={props.operatorStatus === OPERATOR_STATUS.CALLING 
              ? "pr-2 cursorDisabled" : "pr-2 cursorPointer"}
            onClick={() => {
              if (props.operatorStatus !== OPERATOR_STATUS.CALLING) {
                props.backToMenu();
              }
            }}
          />
          <span 
            className={props.operatorStatus === OPERATOR_STATUS.CALLING 
              ? "cursorDisabled" : "cursorPointer"}
            onClick={() => {
              if (props.operatorStatus !== OPERATOR_STATUS.CALLING) {
                props.backToMenu();
              }
            }}
          >
            {getMessage("BACK_TO_MENU")}
          </span>
        </div>
        <div className="container">
          <Row className="justify-content-center">
            <Col className="" md={10}>
              <StatusLabel
                operatorStatus={props.operatorStatus}
                sessionName={props.sessionName}
                sessionCreatedTime={props.sessionCreatedTime}
                isTransfer={props.isTransfer}
                startSession={props.startSession}
              />
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col className="" xs={6} md={5}>
              {
                (props.operatorStatus === OPERATOR_STATUS.LEAVING ||
                props.operatorStatus === OPERATOR_STATUS.CORRESPONDENCE) &&
                <button
                  className="waitingBtn"
                  onClick={() => props.changeStatus(OPERATOR_STATUS.WAITING)}
                >
                  {getMessage("WAITING_BUTTON")}
                </button>
              }
            </Col>
            <Col className="" xs={6} md={5}>
              {
                (props.operatorStatus === OPERATOR_STATUS.WAITING ||
                props.operatorStatus === OPERATOR_STATUS.CORRESPONDENCE ||
                props.operatorStatus === OPERATOR_STATUS.CALLING) &&
                <button
                  className="leavingBtn"
                  onClick={() => {
                    if (props.operatorStatus === OPERATOR_STATUS.CALLING) {
                      props.showTransferDestinationModal();
                    } else {
                      props.changeStatus(OPERATOR_STATUS.LEAVING);
                    }
                  }}
                >
                  {props.operatorStatus === OPERATOR_STATUS.CALLING 
                    ? getMessage("TRANSFER_BUTTON") 
                    : getMessage("LEAVING_BUTTON")}
                </button>
              }
            </Col>
          </Row>
          <div className="d-flex justify-content-center mt-1">
            {`${getMessage("NUMBER_OF_CALLS_WAITING")}: 
              ${getMessage("COUNT_MEETINGS", { count: props.numberOfCallsWaiting })}`}
          </div>
          {
            props.isWebWorkerError &&
            <div className="justify-content-center text-center error-message mt-1">
              {getMessage("SERVER_UNREACHABLE_ERROR")}<br />
              {getMessage("NETWORK_ERROR")}
            </div>
          }
        </div>
      </div>
    </>
  );
};

export default CallWaiting;
